import axios from 'axios';

export default axios.create({
  // baseURL: `http://localhost:4000`,
  headers: {'Authorization': `Bearer ${localStorage.getItem('accessToken')}`},
  baseURL: `https://admin-4-lm.com/admin`
});
